import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./EnrichedIcon.less";
import type { IEnrichedIconProps } from "./EnrichedIcon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 116 116"
    {...props}
  >
    <path
      fill="#F1F4FA"
      d="M58 109c28.167 0 51-22.833 51-51 0-28.166-22.833-51-51-51C29.834 7 7 29.834 7 58c0 28.167 22.834 51 51 51"
    />
    <path fill="#ACB8C3" d="M84.5 25a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M67.555 7.56a1.5 1.5 0 0 0-2.122-2.12l-3.936 3.936-3.936-3.937a1.5 1.5 0 0 0-2.122 2.122l3.937 3.936-3.937 3.936a1.5 1.5 0 0 0 2.122 2.122l3.936-3.937 3.936 3.937a1.5 1.5 0 0 0 2.122-2.122l-3.937-3.936z"
      clipRule="evenodd"
    />
    <path fill="#C7D0D9" d="M92.5 105a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7" />
    <path
      fill="#C7D0D9"
      fillRule="evenodd"
      d="M24.067 81.5a1.5 1.5 0 0 0-3 0v5.567H15.5a1.5 1.5 0 0 0 0 3h5.567v5.567a1.5 1.5 0 0 0 3 0v-5.567h5.566a1.5 1.5 0 0 0 0-3h-5.566zM103 29a4 4 0 1 0 0 8 4 4 0 0 0 0-8m-6 4a6 6 0 1 1 12 0 6 6 0 0 1-12 0"
      clipRule="evenodd"
    />
    <path
      fill="#ACB8C3"
      d="m73.395 88 5.576 25.525c.224 1.027-.88 1.833-1.797 1.312l-18.569-10.558a1.22 1.22 0 0 0-1.21 0l-18.57 10.558c-.916.521-2.02-.285-1.796-1.312L42.605 88"
    />
    <path
      fill="#C7D0D9"
      d="M58 92c18.778 0 34-15.222 34-34S76.778 24 58 24 24 39.222 24 58s15.222 34 34 34"
    />
    <path
      fill="#ACB8C3"
      d="m59.811 40.322 5.159 10.162h8.793a2.406 2.406 0 0 1 1.732 4.134l-8.07 7.929 4.47 10.273a2.435 2.435 0 0 1-3.47 3.047l-10.81-6.081-10.812 6.081a2.435 2.435 0 0 1-3.469-3.047l4.473-10.273-8.074-7.946a2.407 2.407 0 0 1 1.732-4.134h8.793l5.163-10.145a2.482 2.482 0 0 1 4.386 0z"
    />
  </svg>
);
const SvgEnrichedIconWinGreyscale = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IEnrichedIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("enriched-icon bds-enriched-icon", className, {
        ["bds-enriched-icon-" + size]: size,
        ["enriched-icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgEnrichedIconWinGreyscale);
export default Memo;
